<template>
    <div>
        <section class="noteam">
            <v-container>
                <v-row>
                    <v-col cols="14" offset="1" sm="16" offset-sm="0">
                        <h2 class="section-subtitle">Můj tým</h2>
                        <v-row>
                            <v-col cols="16" offset="0" sm="8" offset-sm="4">
                                <p class="noteam__description">Nejste členem týmu. Můžete se k nějakému přidat nebo si založit vlastní.</p>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="16" offset="0" sm="10" offset-sm="3">
                                <v-card dark flat>
                                    <v-card-text>
                                        <v-expansion-panels flat>
                                            <v-expansion-panel>
                                                <v-expansion-panel-header>
                                                    Přidat se k jinému týmu
                                                </v-expansion-panel-header>
                                                <v-expansion-panel-content>
                                                    <v-autocomplete
                                                            label="Název týmu"
                                                            v-model="selectedTeam"
                                                            :items="suggestedTeams"
                                                            :loading="loadingSuggest"
                                                            :search-input.sync="searchTeam"
                                                            item-text="label"
                                                            item-value="id"
                                                            return-object
                                                            required></v-autocomplete>
                                                    <v-btn type="submit" dark color="primary" class="noteam__floatright"
                                                           :disabled="joining || !canJoin" :loading="joining"
                                                           @click.prevent="joinTeam">
                                                        Přidat se
                                                    </v-btn>
                                                </v-expansion-panel-content>
                                            </v-expansion-panel>

                                            <v-expansion-panel>
                                                <v-expansion-panel-header>
                                                    Založit nový
                                                </v-expansion-panel-header>
                                                <v-expansion-panel-content>
                                                    <v-text-field
                                                            label="Název týmu"
                                                            v-model="newTeamName"
                                                            :rules="rules.teamName"
                                                            :loading="loadingCheckName"
                                                            validate-on-blur
                                                    ></v-text-field>
                                                    <v-btn type="submit" color="primary" class="noteam__floatright"
                                                           :disabled="creating || !canCreate" :loading="creating"
                                                           @click.prevent="createTeam">
                                                        Založit nový tým
                                                    </v-btn>
                                                </v-expansion-panel-content>
                                            </v-expansion-panel>
                                        </v-expansion-panels>
                                    </v-card-text>
                                </v-card>
                            </v-col>
                        </v-row>

                        <my-requests v-if="myRequests.length > 0" :requests="myRequests" />

                    </v-col>
                </v-row>
            </v-container>
        </section>
    </div>
</template>

<script>
    import { validator } from '../../plugins/validator'
    import {
        SUGGEST_REQUEST,
        CHECK_NAME_REQUEST,
        CREATE_REQUEST,
        JOIN_TEAM_REQUEST,
        GET_MY_TEAM_REQUESTS_REQUEST,
    } from '../../store/actions/team'
    import MyRequests from './MyRequests';

    export default {
        name: 'NoTeam',
        components: { MyRequests },
        data () {
            return {
                selectedTeam: null,
                newTeamName: '',
                team: null,
                searchTeam: '',
                lastSearchTerm: '',
                errorMessage: '',
                creating: false,
                joining: false,
                loadingCheckName: false,
                isTeamNameUnique: true,
                loadingSuggest: false,
                suggestedTeams: [],
                myRequests: [],
            };
        },
        computed: {
            canJoin () {
                return this.selectedTeam !== null;
            },
            canCreate () {
                return this.newTeamName !== '' && this.isNameAvailable;
            },
            showErrorMessage () {
                return this.errorMessage !== '';
            },
            isNameAvailable () {
                return this.isTeamNameUnique || 'Toto jméno týmu je již obsazeno, zvolte prosím jiné.';
            },
            rules () {
                return {
                    teamName: [validator.required, validator.teamName, this.isNameAvailable],
                };
            },
        },
        watch: {
            async newTeamName (name) {
                if (validator.teamName(name) !== true) {
                    return;
                }

                try {
                    this.loadingCheckName = true;
                    this.isTeamNameUnique = await this.$store.dispatch('team/' + CHECK_NAME_REQUEST, { name });
                } catch (e) {
                } finally {
                    this.loadingCheckName = false;
                }
            },
            searchTeam (term) {
                setTimeout(async () => {
                    if (term === null || term === undefined || term.length < 2 || this.lastSearchTerm === term) {
                        return;
                    }

                    try {
                        this.loadingSuggest = true;
                        this.suggestedTeams = await this.$store.dispatch('team/' + SUGGEST_REQUEST, { term });
                        this.lastSearchTerm = term;
                    } catch (e) {
                    } finally {
                        this.loadingSuggest = false;
                    }

                }, 200);
            },
        },
        methods: {
            async createTeam () {
                if (!this.canCreate) {
                    return;
                }

                try {
                    this.creating = true;
                    await this.$store.dispatch('team/' + CREATE_REQUEST, { name: this.newTeamName });
                    this.$toast.success('Tým byl úspěšně založen.');
                    this.newTeamName = '';
                    this.$router.push({ name: 'dashboard' });
                } catch (e) {
                    this.$toast.error('Při zakládání týmu došlo k chybě. Zkuste to později.');
                } finally {
                    this.creating = false;
                }
            },
            async joinTeam () {
                if (!this.canJoin) {
                    return;
                }

                try {
                    this.joining = true;
                    await this.$store.dispatch('team/' + JOIN_TEAM_REQUEST, { teamId: this.selectedTeam.id });
                    this.$toast.success('Žádost o připojení k týmu byla úspěšně odeslána. Počkejte na její schválení.');
                    const request = {
                        team: {
                            id: this.selectedTeam.id,
                            name: this.selectedTeam.label,
                            blazon: this.selectedTeam.blazon,
                        },
                        created: (new Date()).toISOString(),
                    }
                    this.myRequests.push(request);
                    this.selectedTeam = null;
                    this.searchTeam = '';
                    this.lastSearchTerm = '';
                } catch (e) {
                    this.$toast.error('Při odesílání žádosti došlo k chybě. Zkuste to později.');
                } finally {
                    this.joining = false;
                }
            },
        },
        async created () {
            try {
                this.myRequests = await this.$store.dispatch('team/' + GET_MY_TEAM_REQUESTS_REQUEST);
            } catch (e) {
            }
        },
    }
</script>
